(function () {
  var FLAG = "ap_cart_drawer";
  var BUNDLE_CACHE_KEY = "ap_cart_bundle_groups_v3";
  var CART_GROUP_CACHE_KEY = "ap_cart_merch_groups_v1";
  var root = document.querySelector("[data-ap-cart]");
  if (!root) return;

  var state = {
    cart: null,
    cartFetch: null,
    refreshTimer: null,
    recsTimer: null,
    mutationTimer: null,
    recommendationsFor: null,
    recommendationsAbort: null,
    groupRecommendations: {},
    groupRecommendationAborts: {},
    bundleSuggestions: {},
    bundleSuggestionHtml: {},
    bundleSuggestionAborts: {},
    bundleGroupsLoaded: false,
    bundleGroupsLoading: null,
    bundleProductGroups: {},
    cartGroupsLoaded: false,
    cartGroupsLoading: null,
    cartProductGroups: {},
    errorTimer: null,
    loyaltyTimer: null,
    protectionCleanupKey: null,
    recommendationsPrimedFor: null
  };

  var BUNDLE_GROUPS = [
    { key: "regular-hotel", label: "Hotel fragrance oils", handle: "hotel-collection-fragrance-oils" },
    { key: "regular-perfume", label: "Perfume fragrance oils", handle: "perfume-fragrance-oils" },
    { key: "regular-nature", label: "Nature fragrance oils", handle: "nature-inspired-fragrance-oils" },
    { key: "waterless-oils", label: "Waterless fragrance oils", handle: "waterless-fragrance-oils-1" },
    { key: "incense-sticks", label: "Handcrafted incense sticks", handle: "incense-sticks" },
    { key: "perfume-body-oils", label: "Perfume body oils", handle: "perfume-body-oils" },
    { key: "bracelets", label: "Bracelets", handle: "bracelets" }
  ];

  var CART_GROUPS = [
    { key: "humidifying-diffusers", label: "Humidifying diffusers", handle: "humidifying-scent-diffusers", recommendations: true },
    { key: "waterless-diffusers", label: "Waterless diffusers", handle: "waterless-scent-diffusers", recommendations: true },
    { key: "sand-candles", label: "Sand candles", handle: "sand-candle" },
    { key: "magic-spell-candles", label: "Magic spell candles", handle: "magic-spell-candles" },
    { key: "incense-holders", label: "Incense holders", handle: "incense-holders" }
  ];

  function hasFlag() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("ap_cart") === "1") {
        window.localStorage.setItem(FLAG, "1");
        return true;
      }
      if (params.get("ap_cart") === "0") {
        window.localStorage.setItem(FLAG, "0");
        return false;
      }
      return window.localStorage.getItem(FLAG) !== "0";
    } catch (e) {
      return true;
    }
  }

  function money(cents) {
    cents = Number(cents || 0);
    var amount = cents / 100;
    return "$" + (Number.isInteger(amount) ? String(amount) : amount.toFixed(2));
  }

  function normalizePrice(value) {
    if (typeof value === "string") {
      value = value.replace(/[^0-9.]/g, "");
      if (value.indexOf(".") !== -1) return Math.round(Number(value) * 100);
    }
    return Number(value || 0);
  }

  function productPrice(product, variant) {
    var price = (variant && variant.price != null) ? variant.price : product && product.price;
    price = normalizePrice(price);
    if (!price) return "";
    return money(price);
  }

  function api(path, options) {
    options = options || {};
    options.credentials = "same-origin";
    options.headers = Object.assign({
      "Accept": "application/json"
    }, options.headers || {});
    return fetch(path, options).then(function (res) {
      if (!res.ok) throw new Error("Cart request failed: " + res.status);
      return res.json();
    });
  }

  function hiddenCartUrl(url) {
    if (!/\/cart\/add(\.js)?(\?|$)/.test(String(url || ""))) return url;
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set("hide_upez_cart", "true");
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      return String(url).indexOf("?") === -1
        ? String(url) + "?hide_upez_cart=true"
        : String(url) + "&hide_upez_cart=true";
    }
  }

  function isCollectionPage() {
    return /^\/collections(\/|$)/.test(window.location.pathname);
  }

  function shouldOpenAfterAdd() {
    return !isCollectionPage();
  }

  function openOrRefreshAfterAdd() {
    return fetchCart().then(function () {
      if (shouldOpenAfterAdd()) openCart({ skipRefresh: true });
      else bridgeLoyaltyWidget();
    });
  }

  function showError(message) {
    var error = root.querySelector("[data-ap-cart-error]");
    if (!error) return;
    window.clearTimeout(state.errorTimer);
    error.textContent = message || "We couldn't update your cart. Please try again.";
    error.hidden = false;
    state.errorTimer = window.setTimeout(function () {
      error.hidden = true;
    }, 5200);
  }

  function clearError() {
    var error = root.querySelector("[data-ap-cart-error]");
    if (error) error.hidden = true;
    window.clearTimeout(state.errorTimer);
  }

  function setLineBusy(key, busy) {
    root.querySelectorAll("[data-ap-cart-qty]").forEach(function (button) {
      if (button.getAttribute("data-ap-cart-qty") !== key) return;
      button.disabled = busy;
      button.classList.toggle("is-busy", busy);
    });
  }

  function installScrollStyles() {
    if (document.getElementById("ap-cart-scroll-fix")) return;
    var style = document.createElement("style");
    style.id = "ap-cart-scroll-fix";
    style.textContent = [
      ".ap-cart__panel{display:flex!important;flex-direction:column!important;overflow:hidden!important;}",
      ".ap-cart__header,.ap-cart__footer{flex:0 0 auto!important;}",
      ".ap-cart__body{flex:1 1 auto!important;min-height:0!important;overflow-x:hidden!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;touch-action:pan-y!important;overscroll-behavior:contain!important;}",
      ".ap-cart__items{overflow:visible!important;}"
    ].join("");
    document.head.appendChild(style);
  }

  function installScrollGuards() {
    if (root.__apCartScrollGuards) return;
    root.__apCartScrollGuards = true;
    var lastTouchY = 0;

    function scrollContainer(target) {
      return target && target.closest ? target.closest(".ap-cart__body") : null;
    }

    function canScroll(el) {
      return el && el.scrollHeight > el.clientHeight + 1;
    }

    function atTop(el) {
      return el.scrollTop <= 0;
    }

    function atBottom(el) {
      return el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
    }

    root.addEventListener("wheel", function (event) {
      var body = scrollContainer(event.target);
      if (!body) return;
      event.stopPropagation();
      if (!canScroll(body)) {
        event.preventDefault();
        return;
      }
      body.scrollTop += event.deltaY;
      event.preventDefault();
      if ((event.deltaY < 0 && atTop(body)) || (event.deltaY > 0 && atBottom(body))) {
        event.preventDefault();
      }
    }, { passive: false, capture: true });

    root.addEventListener("touchstart", function (event) {
      if (!scrollContainer(event.target) || !event.touches || !event.touches.length) return;
      lastTouchY = event.touches[0].clientY;
    }, { passive: true, capture: true });

    root.addEventListener("touchmove", function (event) {
      var body = scrollContainer(event.target);
      if (!body || !event.touches || !event.touches.length) return;
      var currentY = event.touches[0].clientY;
      var deltaY = lastTouchY - currentY;
      lastTouchY = currentY;
      event.stopPropagation();
      if (!canScroll(body)) {
        event.preventDefault();
        return;
      }
      if ((deltaY < 0 && atTop(body)) || (deltaY > 0 && atBottom(body))) {
        event.preventDefault();
      }
    }, { passive: false, capture: true });
  }

  function fetchCart() {
    if (state.cartFetch) return state.cartFetch;
    state.cartFetch = api("/cart.js?ap_cart=1&t=" + Date.now()).then(function (cart) {
      state.cart = cart;
      render(cart);
      return cart;
    }).catch(function () {}).finally(function () {
      state.cartFetch = null;
    });
    return state.cartFetch;
  }

  function scheduleCartRefresh(delay) {
    window.clearTimeout(state.refreshTimer);
    state.refreshTimer = window.setTimeout(function () {
      fetchCart().then(bridgeLoyaltyWidget);
    }, delay == null ? 120 : delay);
  }

  function changeLine(key, quantity) {
    return api("/cart/change.js?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    }).then(function (cart) {
      state.cart = cart;
      clearError();
      render(cart);
      document.dispatchEvent(new CustomEvent("ap-cart:updated", { bubbles: true, detail: cart }));
      return cart;
    });
  }

  function updateCart(payload) {
    return api("/cart/update.js?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (cart) {
      state.cart = cart;
      clearError();
      render(cart);
      document.dispatchEvent(new CustomEvent("ap-cart:updated", { bubbles: true, detail: cart }));
      return cart;
    });
  }

  function addVariant(variantId, quantity, properties, sellingPlan) {
    var item = {
      id: Number(variantId),
      quantity: quantity || 1,
      properties: properties || {}
    };
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    return api("/cart/add.js?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [item]
      })
    }).then(function () {
      clearError();
      return fetchCart();
    });
  }

  function setCartMutating(mutating) {
    window.clearTimeout(state.mutationTimer);
    root.classList.toggle("is-mutating", !!mutating);
    if (mutating) {
      state.mutationTimer = window.setTimeout(function () {
        root.classList.remove("is-mutating");
      }, 900);
    }
  }

  function openCart(options) {
    if (!root.classList.contains("is-enabled")) return;
    var wasOpen = root.classList.contains("is-open");
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add("ap-cart-lock");
    if (state.cart) render(state.cart);
    if (!options || !options.skipRefresh) fetchCart().then(bridgeLoyaltyWidget);
    else bridgeLoyaltyWidget();
    startLoyaltyBridgeLoop();
    if (!wasOpen) trackCartEvent("cart_opened", {
      trigger: options && options.trigger ? options.trigger : ""
    });
  }

  function closeCart() {
    var wasOpen = root.classList.contains("is-open");
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("ap-cart-lock");
    window.clearInterval(state.loyaltyTimer);
    if (wasOpen) trackCartEvent("cart_closed");
  }

  function imageUrl(src, width) {
    if (!src) return "";
    if (src.indexOf("//") === 0) src = window.location.protocol + src;
    try {
      var url = new URL(src);
      url.searchParams.set("width", String(width || 220));
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function isProtectionItem(item) {
    var title = String((item && item.product_title) || (item && item.title) || "").toLowerCase();
    return /shipping protection|package protection|free unlimited return|green shipping protection/.test(title);
  }

  function eligibleItems(cart) {
    return (cart.items || []).filter(function (item) {
      return !isProtectionItem(item);
    });
  }

  function eligibleCartTotal(cart) {
    return eligibleItems(cart).reduce(function (sum, item) {
      var lineTotal = item.final_line_price != null ? item.final_line_price : item.line_price;
      return sum + Number(lineTotal || 0);
    }, 0);
  }

  function eligibleCartOriginalTotal(cart) {
    return eligibleItems(cart).reduce(function (sum, item) {
      return sum + Number(item.original_line_price || item.line_price || 0);
    }, 0);
  }

  function cartLineByKey(key) {
    var cart = state.cart || { items: [] };
    for (var i = 0; i < (cart.items || []).length; i += 1) {
      if (cart.items[i].key === key) return cart.items[i];
    }
    return null;
  }

  function recommendationSource(recCard) {
    if (!recCard) return { source: "cart_drawer" };
    var bundleTrack = recCard.closest("[data-ap-cart-bundle-suggestions-track]");
    if (bundleTrack) {
      return {
        source: "bundle_suggestion",
        source_key: bundleTrack.getAttribute("data-ap-cart-bundle-suggestions-track") || ""
      };
    }
    var groupTrack = recCard.closest("[data-ap-cart-group-recs-track]");
    if (groupTrack) {
      return {
        source: "collection_pairing",
        source_key: groupTrack.getAttribute("data-ap-cart-group-recs-track") || ""
      };
    }
    if (recCard.closest("[data-ap-cart-recs-track]")) {
      return { source: "curated_pairing" };
    }
    return { source: "recommendation" };
  }

  function trackCartEvent(name, payload) {
    try {
      var cart = state.cart || { items: [] };
      var items = eligibleItems(cart);
      var quantity = items.reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);
      var body = Object.assign({
        visitor_uuid: window.__ap_visitor || "",
        page: window.location.pathname,
        cart_items: quantity,
        cart_line_count: items.length,
        cart_total: Number(cart.total_price || 0) / 100,
        cart_token: cart.token || "",
        drawer_open: root.classList.contains("is-open"),
        via: "ap_cart_drawer"
      }, payload || {});
      if (typeof window.__APEvent === "function") {
        window.__APEvent(name, body);
        return;
      }
      window.setTimeout(function () {
        try {
          if (typeof window.__APEvent === "function") window.__APEvent(name, body);
        } catch (e) {}
      }, 300);
    } catch (e) {}
  }

  function lineProperties(item) {
    var props = item.properties || {};
    var html = Object.keys(props).filter(function (key) {
      return key.charAt(0) !== "_" && props[key] != null && props[key] !== "";
    }).map(function (key) {
      return escapeHtml(key) + ": " + escapeHtml(String(props[key]));
    }).join("<br>");
    return html ? '<p class="ap-cart__properties">' + html + "</p>" : "";
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(String(value));
    return String(value).replace(/[^a-zA-Z0-9_-]/g, "\\$&");
  }

  function renderShipping(cart) {
    var threshold = Number(root.dataset.freeShippingThreshold || 4999);
    var total = eligibleCartTotal(cart);
    var remaining = Math.max(0, threshold - total);
    var text = root.querySelector("[data-ap-cart-shipping-text]");
    var bar = root.querySelector("[data-ap-cart-shipping-progress]");
    if (text) {
      text.innerHTML = remaining === 0
        ? "Unlocked for this order"
        : escapeHtml(money(remaining)) + " away";
    }
    if (bar) {
      bar.style.width = Math.max(0, Math.min(100, Math.round((total / threshold) * 100))) + "%";
    }
  }

  function renderItems(cart) {
    var mount = root.querySelector("[data-ap-cart-items]");
    var empty = root.querySelector("[data-ap-cart-empty]");
    var items = eligibleItems(cart);
    var bundleCounts = bundleGroupCounts(cart);
    if (!mount) return;
    var bundleScroll = bundleSuggestionScrollState();
    if (empty) empty.hidden = items.length > 0;
    if (!state.bundleGroupsLoaded || !state.cartGroupsLoaded) {
      mount.innerHTML = items.map(function (item) {
        return renderCartItem(item, bundleCounts, true);
      }).join("");
      restoreBundleSuggestionScroll(bundleScroll);
      if (root.classList.contains("is-open")) loadCartGrouping();
      else warmCartGrouping();
      return;
    }

    var bundleGroups = {};
    var cartGroups = {};
    var otherItems = [];
    items.forEach(function (item) {
      var bundleKey = bundleGroupKeyForItem(item);
      var cartKey = cartGroupKeyForItem(item);
      if (bundleKey) {
        if (!bundleGroups[bundleKey]) bundleGroups[bundleKey] = [];
        bundleGroups[bundleKey].push(item);
        return;
      }
      if (cartKey) {
        if (!cartGroups[cartKey]) cartGroups[cartKey] = [];
        cartGroups[cartKey].push(item);
        return;
      }
      otherItems.push(item);
    });

    var html = [];
    BUNDLE_GROUPS.forEach(function (group) {
      if (!bundleGroups[group.key] || !bundleGroups[group.key].length) return;
      html.push(renderBundleItemGroup(group, bundleGroups[group.key], bundleCounts[group.key] || 0));
    });
    CART_GROUPS.forEach(function (group) {
      if (!cartGroups[group.key] || !cartGroups[group.key].length) return;
      html.push(renderCartItemGroup(group, cartGroups[group.key], setupNudgeForGroup(group, bundleGroups)));
    });
    if (otherItems.length) html.push(renderCartItemGroup({ label: "Other items" }, otherItems));
    mount.innerHTML = html.join("");
    restoreBundleSuggestionScroll(bundleScroll);
  }

  function bundleSuggestionScrollState() {
    var scroll = {};
    root.querySelectorAll("[data-ap-cart-bundle-suggestions-track]").forEach(function (track) {
      var groupKey = track.getAttribute("data-ap-cart-bundle-suggestions-track");
      if (groupKey) scroll[groupKey] = track.scrollLeft || 0;
    });
    return scroll;
  }

  function restoreBundleSuggestionScroll(scroll) {
    Object.keys(scroll || {}).forEach(function (groupKey) {
      var track = root.querySelector('[data-ap-cart-bundle-suggestions-track="' + cssEscape(groupKey) + '"]');
      if (track) track.scrollLeft = scroll[groupKey];
    });
  }

  function renderCartItem(item, bundleCounts, showBundleBadge) {
    var price = linePriceHtml(item, bundleCounts);
    var variant = item.variant_title && item.variant_title !== "Default Title"
      ? '<p class="ap-cart__variant">' + escapeHtml(item.variant_title) + "</p>"
      : "";
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? '<p class="ap-cart__plan">' + escapeHtml(item.selling_plan_allocation.selling_plan.name || "Subscription") + "</p>"
      : "";
    var bundleBadge = showBundleBadge ? bundleLineBadge(item, bundleCounts) : "";
    return [
      '<article class="ap-cart__item" data-ap-cart-line="' + escapeHtml(item.key) + '">',
        item.image
          ? '<img class="ap-cart__image" src="' + escapeHtml(imageUrl(item.image, 220)) + '" alt="' + escapeHtml(item.product_title || item.title) + '" loading="lazy">'
          : '<div class="ap-cart__image ap-cart__image--empty" aria-hidden="true"><span></span></div>',
        '<div class="ap-cart__item-main">',
          '<div class="ap-cart__item-top">',
            '<div>',
              '<a class="ap-cart__item-title" href="' + escapeHtml(item.url || "#") + '">' + escapeHtml(item.product_title || item.title) + "</a>",
              variant,
              plan,
              lineProperties(item),
              price,
            '</div>',
            '<div class="ap-cart__item-actions">',
              '<div class="ap-cart__qty" aria-label="Quantity">',
                '<button type="button" data-ap-cart-qty="' + escapeHtml(item.key) + '" data-qty="' + (Number(item.quantity) - 1) + '" aria-label="Decrease quantity">-</button>',
                '<span>' + Number(item.quantity || 0) + '</span>',
                '<button type="button" data-ap-cart-qty="' + escapeHtml(item.key) + '" data-qty="' + (Number(item.quantity) + 1) + '" aria-label="Increase quantity">+</button>',
              '</div>',
              '<button type="button" class="ap-cart__remove" data-ap-cart-qty="' + escapeHtml(item.key) + '" data-qty="0" aria-label="Remove ' + escapeHtml(item.product_title || item.title) + '">',
                '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="m19 6-1 14H6L5 6"/><path d="M10 11v5"/><path d="M14 11v5"/></svg>',
              '</button>',
            '</div>',
          '</div>',
          bundleBadge,
        '</div>',
      '</article>'
    ].join("");
  }

  function linePriceHtml(item, bundleCounts) {
    var original = Number(item.original_line_price || 0);
    var final = Number(item.final_line_price || 0);
    var discount = lineDiscountAmount(item, bundleCounts);
    var displayFinal = discount > 0 && original > discount ? original - discount : final || original;
    var compare = discount > 0 && original > displayFinal
      ? '<span class="ap-cart__compare">' + money(original) + "</span>"
      : "";
    var discountLabel = discount > 0 ? lineDiscountLabel(item, discount, original) : "";
    return [
      '<div class="ap-cart__price-row">',
        '<span class="ap-cart__price">' + money(displayFinal) + "</span>",
        compare,
        discountLabel,
      '</div>'
    ].join("");
  }

  function lineDiscountAmount(item, bundleCounts) {
    var original = Number(item.original_line_price || 0);
    var final = Number(item.final_line_price || 0);
    var discount = Math.max(0, original - final);
    discount = Math.max(discount, Number(item.line_level_total_discount || 0), Number(item.total_discount || 0));
    var allocated = 0;
    (item.discount_allocations || []).forEach(function (allocation) {
      allocated += Number(allocation.amount || 0);
    });
    return Math.max(discount, allocated, estimatedBundleDiscountAmount(item, bundleCounts));
  }

  function actualLineDiscountAmount(item) {
    var original = Number(item.original_line_price || 0);
    var final = Number(item.final_line_price || 0);
    var discount = Math.max(0, original - final);
    discount = Math.max(discount, Number(item.line_level_total_discount || 0), Number(item.total_discount || 0));
    var allocated = 0;
    (item.discount_allocations || []).forEach(function (allocation) {
      allocated += Number(allocation.amount || 0);
    });
    return Math.max(discount, allocated);
  }

  function estimatedBundleDiscountAmount(item, bundleCounts) {
    if (!bundleCounts) return 0;
    var groupKey = bundleGroupKeyForItem(item);
    if (!groupKey) return 0;
    var tier = bundleTier(bundleCounts[groupKey] || 0);
    if (!tier.percent) return 0;
    return Math.round(Number(item.original_line_price || 0) * tier.percent / 100);
  }

  function lineDiscountLabel(item, discount, original) {
    var percent = original > 0 ? Math.round((discount / original) * 100) : 0;
    var label = percent >= 1 ? percent + "% off" : "Save " + money(discount);
    return '<span class="ap-cart__saving">' + escapeHtml(label) + "</span>";
  }

  function renderBundleItemGroup(group, items, count) {
    var counts = {};
    counts[group.key] = count;
    return [
      '<section class="ap-cart__bundle-group">',
        bundleGroupHeader(group, count),
        bundleSuggestionShell(group, count),
        items.map(function (item) {
          return renderCartItem(item, counts, false);
        }).join(""),
      '</section>'
    ].join("");
  }

  function bundleSuggestionShell(group, count) {
    if (!group || !group.handle || count >= 5) return "";
    var cachedHtml = state.bundleSuggestionHtml[group.key] || "";
    var hidden = cachedHtml ? "" : " hidden";
    return [
      '<section class="ap-cart__recs ap-cart__recs--bundle" data-ap-cart-bundle-suggestions="' + escapeHtml(group.key) + '" data-ap-cart-bundle-handle="' + escapeHtml(group.handle) + '"' + hidden + '>',
        '<div class="ap-cart__recs-heading">',
          '<div><span class="ap-cart__recs-kicker">Add to unlock savings</span></div>',
          '<div class="ap-cart__recs-nav" aria-label="' + escapeHtml(compactBundleLabel(group)) + ' suggestions navigation">',
            '<button type="button" data-ap-cart-bundle-suggestions-prev="' + escapeHtml(group.key) + '" aria-label="Previous suggestions">',
              '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
            '</button>',
            '<button type="button" data-ap-cart-bundle-suggestions-next="' + escapeHtml(group.key) + '" aria-label="Next suggestions">',
              '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
            '</button>',
          '</div>',
        '</div>',
        '<div class="ap-cart__recs-track" data-ap-cart-bundle-suggestions-track="' + escapeHtml(group.key) + '">' + cachedHtml + '</div>',
      '</section>'
    ].join("");
  }

  function renderCartItemGroup(group, items, setupNudge) {
    var recs = group.recommendations ? groupRecommendationShell(group, items) : "";
    return [
      '<section class="ap-cart__item-group">',
        '<div class="ap-cart__item-group-head">',
          '<span>' + escapeHtml(group.label || "Items") + '</span>',
          '<strong>' + itemGroupCount(items) + '</strong>',
        '</div>',
        items.map(function (item) {
          return renderCartItem(item, {}, false);
        }).join(""),
        setupNudge || "",
        recs,
      '</section>'
    ].join("");
  }

  function setupNudgeForGroup(group, bundleGroups) {
    var key = group && group.key;
    if (key === "humidifying-diffusers" && !hasAnyBundleGroup(bundleGroups, ["regular-hotel", "regular-perfume", "regular-nature"])) {
      return setupNudgeHtml("Complete your setup", "Add a compatible humidifying oil for your diffuser.");
    }
    if (key === "waterless-diffusers" && !hasAnyBundleGroup(bundleGroups, ["waterless-oils"])) {
      return setupNudgeHtml("Complete your setup", "Add a waterless fragrance oil for your cold-air diffuser.");
    }
    return "";
  }

  function hasAnyBundleGroup(bundleGroups, keys) {
    return keys.some(function (key) {
      return bundleGroups[key] && bundleGroups[key].length;
    });
  }

  function setupNudgeHtml(title, copy) {
    return [
      '<div class="ap-cart__setup-nudge">',
        '<span>' + escapeHtml(title) + '</span>',
        '<p>' + escapeHtml(copy) + '</p>',
      '</div>'
    ].join("");
  }

  function groupRecommendationShell(group, items) {
    var source = (items || []).find(function (item) {
      return item && item.product_id;
    });
    if (!source) return "";
    return [
      '<section class="ap-cart__recs ap-cart__recs--group" data-ap-cart-group-recs="' + escapeHtml(group.key) + '" data-ap-cart-group-recs-source="' + escapeHtml(source.product_id) + '" hidden>',
        '<div class="ap-cart__recs-heading">',
          '<div><span class="ap-cart__recs-kicker">Curated pairings</span></div>',
          '<div class="ap-cart__recs-nav" aria-label="' + escapeHtml(group.label || "Recommendation") + ' recommendation navigation">',
            '<button type="button" data-ap-cart-group-recs-prev="' + escapeHtml(group.key) + '" aria-label="Previous recommendations">',
              '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
            '</button>',
            '<button type="button" data-ap-cart-group-recs-next="' + escapeHtml(group.key) + '" aria-label="Next recommendations">',
              '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
            '</button>',
          '</div>',
        '</div>',
        '<div class="ap-cart__recs-track" data-ap-cart-group-recs-track="' + escapeHtml(group.key) + '"></div>',
      '</section>'
    ].join("");
  }

  function itemGroupCount(items) {
    return (items || []).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
  }

  function bundleGroupHeader(group, count) {
    var tier = bundleTier(count);
    var width = Math.min(100, Math.round((Math.min(count, 5) / 5) * 100));
    return [
      '<div class="ap-cart__bundle-group-head">',
        '<div class="ap-cart__bundle-group-meta">',
          '<span>' + escapeHtml(compactBundleLabel(group)) + '</span>',
          '<strong>' + count + '/5</strong>',
        '</div>',
        '<div class="ap-cart__bundle-group-bar" style="--ap-progress:' + width + '%" aria-hidden="true">',
          '<i class="ap-cart__bundle-goal ap-cart__bundle-goal--three"></i>',
          '<i class="ap-cart__bundle-goal ap-cart__bundle-goal--five"></i>',
          '<span></span>',
        '</div>',
        '<p>' + escapeHtml(bundleGroupProgressCopy(group, count)) + '</p>',
      '</div>'
    ].join("");
  }

  function collectionProductsUrl(handle) {
    return "/collections/" + encodeURIComponent(handle) + "/products.json?limit=250";
  }

  function readBundleGroupCache() {
    try {
      var cached = JSON.parse(window.localStorage.getItem(BUNDLE_CACHE_KEY) || "null");
      if (!cached || !cached.savedAt || Date.now() - cached.savedAt > 86400000 || !cached.groups) return false;
      state.bundleProductGroups = cached.groups;
      state.bundleGroupsLoaded = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  function writeBundleGroupCache() {
    try {
      window.localStorage.setItem(BUNDLE_CACHE_KEY, JSON.stringify({
        savedAt: Date.now(),
        groups: state.bundleProductGroups
      }));
    } catch (e) {}
  }

  function readCartGroupCache() {
    try {
      var cached = JSON.parse(window.localStorage.getItem(CART_GROUP_CACHE_KEY) || "null");
      if (!cached || !cached.savedAt || Date.now() - cached.savedAt > 86400000 || !cached.groups) return false;
      state.cartProductGroups = cached.groups;
      state.cartGroupsLoaded = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  function writeCartGroupCache() {
    try {
      window.localStorage.setItem(CART_GROUP_CACHE_KEY, JSON.stringify({
        savedAt: Date.now(),
        groups: state.cartProductGroups
      }));
    } catch (e) {}
  }

  function loadCartGroups() {
    if (state.cartGroupsLoaded) return Promise.resolve(state.cartProductGroups);
    if (readCartGroupCache()) return Promise.resolve(state.cartProductGroups);
    if (state.cartGroupsLoading) return state.cartGroupsLoading;
    state.cartGroupsLoading = Promise.all(CART_GROUPS.map(function (group) {
      return fetch(collectionProductsUrl(group.handle), {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        products.forEach(function (product) {
          if (!product || !product.id) return;
          var id = String(product.id);
          if (!state.cartProductGroups[id]) state.cartProductGroups[id] = group.key;
        });
      }).catch(function () {});
    })).then(function () {
      state.cartGroupsLoaded = true;
      state.cartGroupsLoading = null;
      writeCartGroupCache();
      if (state.cart) render(state.cart);
      return state.cartProductGroups;
    });
    return state.cartGroupsLoading;
  }

  function loadCartGrouping() {
    return Promise.all([loadBundleGroups(), loadCartGroups()]);
  }

  function warmCartGrouping() {
    if (state.bundleGroupsLoaded && state.cartGroupsLoaded) return;
    if ((state.bundleGroupsLoaded || state.bundleGroupsLoading) && (state.cartGroupsLoaded || state.cartGroupsLoading)) return;
    window.setTimeout(loadCartGrouping, 500);
  }

  function loadBundleGroups() {
    if (state.bundleGroupsLoaded) return Promise.resolve(state.bundleProductGroups);
    if (readBundleGroupCache()) return Promise.resolve(state.bundleProductGroups);
    if (state.bundleGroupsLoading) return state.bundleGroupsLoading;
    state.bundleGroupsLoading = Promise.all(BUNDLE_GROUPS.map(function (group) {
      return fetch(collectionProductsUrl(group.handle), {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        products.forEach(function (product) {
          if (!product || !product.id) return;
          var id = String(product.id);
          if (!state.bundleProductGroups[id]) state.bundleProductGroups[id] = group.key;
        });
      }).catch(function () {});
    })).then(function () {
      state.bundleGroupsLoaded = true;
      state.bundleGroupsLoading = null;
      writeBundleGroupCache();
      if (state.cart) render(state.cart);
      return state.bundleProductGroups;
    });
    return state.bundleGroupsLoading;
  }

  function bundleGroupByKey(key) {
    return BUNDLE_GROUPS.find(function (group) {
      return group.key === key;
    }) || null;
  }

  function bundleGroupKeyForItem(item) {
    if (!item) return "";
    if (!item.product_id) return "";
    return state.bundleProductGroups[String(item.product_id)] || "";
  }

  function cartGroupKeyForItem(item) {
    if (!item) return "";
    if (!item.product_id) return "";
    return state.cartProductGroups[String(item.product_id)] || "";
  }

  function bundleGroupCounts(cart) {
    var counts = {};
    eligibleItems(cart).forEach(function (item) {
      var groupKey = bundleGroupKeyForItem(item);
      if (!groupKey) return;
      counts[groupKey] = (counts[groupKey] || 0) + Number(item.quantity || 0);
    });
    return counts;
  }

  function bundleTier(count) {
    if (count >= 5) return { percent: 20, next: 0, target: 5 };
    if (count >= 3) return { percent: 15, next: 5 - count, target: 5 };
    return { percent: 0, next: 3 - count, target: 3 };
  }

  function bundleProgressCopy(count) {
    var tier = bundleTier(count);
    if (tier.percent === 20) return "20% unlocked";
    if (tier.percent === 15) {
      return "15% unlocked · " + tier.next + " to 20%";
    }
    return tier.next + " to 15%";
  }

  function bundleGroupProgressCopy(group, count) {
    var tier = bundleTier(count);
    var noun = bundleGroupNoun(group);
    if (tier.percent === 20) return "20% off unlocked on " + noun;
    if (tier.percent === 15) {
      return "15% off unlocked · Add " + tier.next + " more " + noun + " for 20% off";
    }
    return "Add " + tier.next + " more " + noun + " for 15% off";
  }

  function bundleGroupNoun(group) {
    var key = group && group.key;
    if (key === "regular-hotel") return "hotel scents";
    if (key === "regular-perfume") return "perfume scents";
    if (key === "regular-nature") return "nature scents";
    if (key === "waterless-oils") return "waterless scents";
    if (key === "incense-sticks") return "incense";
    if (key === "perfume-body-oils") return "body oils";
    if (key === "bracelets") return "bracelets";
    return String(group && group.label || "scents").toLowerCase();
  }

  function bundleLineBadge(item, counts) {
    if (!item) return "";
    var groupKey = bundleGroupKeyForItem(item);
    var group = bundleGroupByKey(groupKey);
    if (!group) return "";
    var count = counts[groupKey] || 0;
    var tier = bundleTier(count);
    var label = tier.percent
      ? tier.percent + "% bundle discount"
      : "Bundle offer · " + bundleProgressCopy(count);
    return [
      '<p class="ap-cart__bundle-line">',
        '<span>' + escapeHtml(compactBundleLabel(group)) + '</span>',
        '<strong>' + escapeHtml(label) + '</strong>',
      '</p>'
    ].join("");
  }

  function compactBundleLabel(group) {
    var key = group && group.key;
    if (key === "regular-hotel") return "Hotel Bundle";
    if (key === "regular-perfume") return "Perfume Bundle";
    if (key === "regular-nature") return "Nature Bundle";
    if (key === "waterless-oils") return "Waterless Bundle";
    if (key === "incense-sticks") return "Incense Bundle";
    if (key === "perfume-body-oils") return "Body Oil Bundle";
    if (key === "bracelets") return "Bracelets Bundle";
    return String(group && group.label || "")
      .replace(/\s+fragrance oils?$/i, "")
      .replace(/\s+oils?$/i, "")
      .replace(/\s+sticks?$/i, "")
      .trim() + " Bundle";
  }

  function renderBundleProgress(cart) {
    var mount = root.querySelector("[data-ap-cart-bundle-progress]");
    if (!mount) return;
    mount.hidden = true;
    mount.innerHTML = "";
    if (!state.bundleGroupsLoaded) {
      if (root.classList.contains("is-open")) loadBundleGroups();
      else warmBundleGroups();
    }
  }

  function renderProtection(cart) {
    var variantId = root.dataset.protectionVariantId;
    var row = root.querySelector("[data-ap-cart-protection]");
    var price = root.querySelector("[data-ap-cart-protection-price]");
    var without = root.querySelector("[data-ap-cart-checkout-without]");
    var checkoutRow = root.querySelector(".ap-cart__checkout-row");
    if (!row) return;
    var enabled = Boolean(variantId) && eligibleItems(cart).length > 0;
    row.hidden = !enabled;
    if (checkoutRow) checkoutRow.hidden = !enabled;
    if (without) without.hidden = !enabled;
    if (price) price.textContent = root.dataset.protectionPrice ? "+" + money(root.dataset.protectionPrice) : "";
  }

  function protectionPrice() {
    return Number(root.dataset.protectionPrice || 0);
  }

  function protectionItem(cart) {
    var variantId = root.dataset.protectionVariantId;
    if (!variantId || !cart) return null;
    return (cart.items || []).find(function (item) {
      return String(item.variant_id) === String(variantId);
    }) || null;
  }

  function checkoutUrl() {
    return "/checkout";
  }

  function checkoutAddUrl(variantId) {
    return "/cart/add?id=" + encodeURIComponent(variantId) +
      "&quantity=1&return_to=" + encodeURIComponent(checkoutUrl());
  }

  function renderTotals(cart) {
    var subtotal = root.querySelector("[data-ap-cart-subtotal]");
    var checkoutTotal = root.querySelector("[data-ap-cart-checkout-total]");
    var checkoutCompare = root.querySelector("[data-ap-cart-checkout-compare]");
    var estimatedSavings = estimatedBundleSavings(cart);
    var displayedSubtotal = Math.max(0, eligibleCartTotal(cart) - estimatedSavings);
    if (subtotal) subtotal.textContent = money(displayedSubtotal);
    if (checkoutTotal) {
      var protectionAddOn = root.dataset.protectionVariantId && eligibleItems(cart).length > 0 && !protectionItem(cart) ? protectionPrice() : 0;
      var total = displayedSubtotal + protectionAddOn;
      var compareTotal = eligibleCartOriginalTotal(cart) + protectionAddOn;
      checkoutTotal.textContent = money(total);
      if (checkoutCompare) {
        checkoutCompare.hidden = !(compareTotal > total);
        checkoutCompare.textContent = compareTotal > total ? money(compareTotal) : "";
      }
    }
  }

  function cleanupOrphanProtection(cart) {
    var protection = protectionItem(cart);
    if (!protection || eligibleItems(cart).length > 0) {
      state.protectionCleanupKey = null;
      return;
    }
    if (state.protectionCleanupKey === protection.key) return;
    state.protectionCleanupKey = protection.key;
    changeLine(protection.key, 0).catch(function () {
      state.protectionCleanupKey = null;
    });
  }

  function estimatedBundleSavings(cart) {
    if (!state.bundleGroupsLoaded) return 0;
    var counts = bundleGroupCounts(cart);
    return eligibleItems(cart).reduce(function (sum, item) {
      return sum + Math.max(0, estimatedBundleDiscountAmount(item, counts) - actualLineDiscountAmount(item));
    }, 0);
  }

  function bridgeLoyaltyWidget() {
    if (!root.classList.contains("is-enabled")) return;
    var host = root.querySelector("[data-ap-cart-loyalty]");
    if (!host) return;
    ensureLoyaltyAccordion(host);
    holdLegacyLoyaltyBridge();
    var widget = findLoyaltyWidget();
    if (!widget) return;
    var panel = host.querySelector("[data-ap-cart-loyalty-panel]") || host;
    if (!panel.contains(widget)) panel.appendChild(widget);
    holdLegacyLoyaltyBridge();
    if (state.cart) widget.dataset.cartPrice = String(Number(state.cart.total_price || 0));
    widget.style.setProperty("display", "flex", "important");
    widget.style.setProperty("width", "100%", "important");
    widget.style.setProperty("margin", "0", "important");
    widget.style.setProperty("box-sizing", "border-box", "important");
    host.hidden = false;
    syncLoyaltyAccordion(host);
  }

  function ensureLoyaltyAccordion(host) {
    if (host.querySelector("[data-ap-cart-loyalty-toggle]")) return;
    var existing = Array.prototype.slice.call(host.childNodes);
    var toggle = document.createElement("button");
    toggle.className = "ap-cart__loyalty-toggle";
    toggle.type = "button";
    toggle.setAttribute("data-ap-cart-loyalty-toggle", "true");
    toggle.setAttribute("aria-expanded", "false");
    toggle.innerHTML = [
      '<span>Rewards</span>',
      '<svg class="ap-cart__loyalty-chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>'
    ].join("");
    var panel = document.createElement("div");
    panel.className = "ap-cart__loyalty-panel";
    panel.setAttribute("data-ap-cart-loyalty-panel", "true");
    panel.hidden = true;
    existing.forEach(function (node) {
      panel.appendChild(node);
    });
    host.textContent = "";
    host.setAttribute("data-ap-loyalty-expanded", "false");
    host.appendChild(toggle);
    host.appendChild(panel);
  }

  function syncLoyaltyAccordion(host) {
    var expanded = host.getAttribute("data-ap-loyalty-expanded") === "true";
    var toggle = host.querySelector("[data-ap-cart-loyalty-toggle]");
    var panel = host.querySelector("[data-ap-cart-loyalty-panel]");
    if (toggle) toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    if (panel) panel.hidden = !expanded;
  }

  function toggleLoyaltyAccordion() {
    var host = root.querySelector("[data-ap-cart-loyalty]");
    if (!host) return;
    var expanded = host.getAttribute("data-ap-loyalty-expanded") === "true";
    host.setAttribute("data-ap-loyalty-expanded", expanded ? "false" : "true");
    syncLoyaltyAccordion(host);
  }

  function holdLegacyLoyaltyBridge() {
    var upnova = document.querySelector("upnova-widget");
    var shadowRoot = upnova && upnova.shadowRoot;
    var legacyHost = shadowRoot && shadowRoot.querySelector("[data-essential-loyalty-upez-host]");
    if (!legacyHost) return;
    if (!legacyHost.querySelector("[data-ap-cart-loyalty-sentinel]")) {
      var sentinel = document.createElement("span");
      sentinel.setAttribute("data-ap-cart-loyalty-sentinel", "true");
      sentinel.hidden = true;
      sentinel.textContent = "points";
      legacyHost.appendChild(sentinel);
    }
  }

  function findLoyaltyWidget() {
    var widget = document.querySelector(".honeypop-cp");
    if (widget) return widget;

    var stage = document.getElementById("essential-loyalty-cart-stage");
    if (stage) {
      widget = Array.prototype.find.call(stage.children, function (el) {
        return el.classList && el.classList.contains("honeypop-cp");
      });
      if (widget) return widget;
    }

    var upnova = document.querySelector("upnova-widget");
    var shadowRoot = upnova && upnova.shadowRoot;
    return shadowRoot ? shadowRoot.querySelector(".honeypop-cp") : null;
  }

  function startLoyaltyBridgeLoop() {
    var attempts = 0;
    window.clearInterval(state.loyaltyTimer);
    bridgeLoyaltyWidget();
    state.loyaltyTimer = window.setInterval(function () {
      attempts += 1;
      bridgeLoyaltyWidget();
      if (!root.classList.contains("is-open") || attempts > 20) {
        window.clearInterval(state.loyaltyTimer);
      }
    }, 250);
  }

  function renderCount(cart) {
    var count = root.querySelector("[data-ap-cart-count]");
    var visibleCount = eligibleItems(cart).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
    if (count) count.textContent = String(visibleCount);
    document.querySelectorAll(".cart-count-bubble span[aria-hidden='true']").forEach(function (el) {
      el.textContent = String(visibleCount);
    });
  }

  function render(cart) {
    renderCount(cart);
    renderShipping(cart);
    renderBundleProgress(cart);
    renderItems(cart);
    hydrateBundleSuggestionVisibility(cart);
    renderProtection(cart);
    renderTotals(cart);
    cleanupOrphanProtection(cart);
    bridgeLoyaltyWidget();
    if (eligibleItems(cart).length && (!state.bundleGroupsLoaded || !state.cartGroupsLoaded)) {
      primeCartUpsells(cart);
    } else {
      scheduleRecommendations(cart);
    }
  }

  function scheduleRecommendations(cart) {
    window.clearTimeout(state.recsTimer);
    state.recsTimer = window.setTimeout(function () {
      renderRecommendations(cart);
    }, root.classList.contains("is-open") ? 120 : 320);
  }

  function renderRecommendations(cart) {
    var hasGroupRecommendations = renderGroupRecommendations();
    var hasBundleSuggestions = renderBundleSuggestions(cart);
    var hasInlineRecommendations = hasGroupRecommendations || hasBundleSuggestions;
    if (hasInlineRecommendations) {
      var fallbackSection = root.querySelector("[data-ap-cart-recs]");
      var fallbackTrack = root.querySelector("[data-ap-cart-recs-track]");
      if (fallbackSection) fallbackSection.hidden = true;
      if (fallbackTrack) fallbackTrack.innerHTML = "";
      return;
    }
    var first = recommendationSourceItem(cart);
    var section = root.querySelector("[data-ap-cart-recs]");
    var track = root.querySelector("[data-ap-cart-recs-track]");
    if (!section || !track) return;
    if (!first || !first.product_id) {
      section.hidden = true;
      track.innerHTML = "";
      return;
    }
    if (state.recommendationsFor === first.product_id) return;
    state.recommendationsFor = first.product_id;
    section.hidden = true;
    track.innerHTML = "";
    if (state.recommendationsAbort) state.recommendationsAbort.abort();
    state.recommendationsAbort = new AbortController();
    fetch("/recommendations/products.json?product_id=" + encodeURIComponent(first.product_id) + "&limit=6&intent=complementary", {
      credentials: "same-origin",
      signal: state.recommendationsAbort.signal,
      headers: { "Accept": "application/json" }
    }).then(function (res) {
      return res.ok ? res.json() : null;
    }).then(function (payload) {
      var products = payload && payload.products ? payload.products : [];
      return filterRecommendationProducts(products, first.product_id);
    }).then(function (products) {
      products = products || [];
      if (!products.length) return;
      return Promise.all(products.map(enrichProduct)).then(function (enriched) {
        var cards = enriched.map(function (product, index) {
          return renderRecommendationCard(product, index);
        });
        track.innerHTML = cards.join("");
        section.hidden = false;
      });
    }).catch(function () {});
  }

  function renderBundleSuggestions(cart) {
    var sections = Array.prototype.slice.call(root.querySelectorAll("[data-ap-cart-bundle-suggestions]"));
    if (!sections.length) return false;
    var cartProductIds = cartProductIdSet(cart);
    sections.forEach(function (section) {
      var groupKey = section.getAttribute("data-ap-cart-bundle-suggestions");
      var handle = section.getAttribute("data-ap-cart-bundle-handle");
      var track = root.querySelector('[data-ap-cart-bundle-suggestions-track="' + cssEscape(groupKey) + '"]');
      if (!groupKey || !handle || !track) return;
      hideCartSuggestionCards(track, cartProductIds);
      var cacheKey = groupKey + ":" + handle;
      if (state.bundleSuggestions[groupKey] === cacheKey && track.children.length) {
        if (hasVisibleSuggestionCards(track)) {
          section.hidden = false;
          return;
        }
      }
      state.bundleSuggestions[groupKey] = cacheKey;
      if (!track.children.length) section.hidden = true;
      if (state.bundleSuggestionAborts[groupKey]) state.bundleSuggestionAborts[groupKey].abort();
      state.bundleSuggestionAborts[groupKey] = new AbortController();
      fetch("/collections/" + encodeURIComponent(handle) + "/products.json?limit=12", {
        credentials: "same-origin",
        signal: state.bundleSuggestionAborts[groupKey].signal,
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        return filterCollectionSuggestionProducts(products, cartProductIds);
      }).then(function (products) {
        products = products || [];
        if (!products.length) return;
        track.innerHTML = products.slice(0, 6).map(function (product, index) {
          return renderRecommendationCard(product, index);
        }).join("");
        state.bundleSuggestionHtml[groupKey] = track.innerHTML;
        hideCartSuggestionCards(track, cartProductIds);
        section.hidden = false;
      }).catch(function () {});
    });
    return true;
  }

  function primeCartUpsells(cart) {
    if (!cart || !eligibleItems(cart).length) return;
    var key = eligibleItems(cart).map(function (item) {
      return [item.product_id || "", item.variant_id || "", item.quantity || 0].join(":");
    }).join("|");
    if (!key || state.recommendationsPrimedFor === key) return;
    state.recommendationsPrimedFor = key;
    loadCartGrouping().then(function () {
      if (state.cart) scheduleRecommendations(state.cart);
    }).catch(function () {});
  }

  function hydrateBundleSuggestionVisibility(cart) {
    var cartProductIds = cartProductIdSet(cart);
    Array.prototype.slice.call(root.querySelectorAll("[data-ap-cart-bundle-suggestions]")).forEach(function (section) {
      var groupKey = section.getAttribute("data-ap-cart-bundle-suggestions");
      var track = root.querySelector('[data-ap-cart-bundle-suggestions-track="' + cssEscape(groupKey) + '"]');
      if (!track || !track.children.length) return;
      hideCartSuggestionCards(track, cartProductIds);
      section.hidden = !hasVisibleSuggestionCards(track);
    });
  }

  function hideCartSuggestionCards(track, cartProductIds) {
    if (!track) return;
    Array.prototype.slice.call(track.querySelectorAll("[data-ap-cart-rec-product]")).forEach(function (card) {
      var productId = card.getAttribute("data-ap-cart-rec-product");
      card.hidden = !!cartProductIds[String(productId)];
    });
  }

  function hasVisibleSuggestionCards(track) {
    if (!track) return false;
    return Array.prototype.slice.call(track.querySelectorAll("[data-ap-cart-rec-product]")).some(function (card) {
      return !card.hidden;
    });
  }

  function cartProductIdSet(cart) {
    var ids = {};
    eligibleItems(cart || { items: [] }).forEach(function (item) {
      if (item && item.product_id) ids[String(item.product_id)] = true;
    });
    return ids;
  }

  function filterCollectionSuggestionProducts(products, cartProductIds) {
    return (products || []).filter(function (product) {
      return product
        && product.id
        && !cartProductIds[String(product.id)]
        && product.available !== false
        && product.variants
        && product.variants[0];
    });
  }

  function renderGroupRecommendations() {
    var sections = Array.prototype.slice.call(root.querySelectorAll("[data-ap-cart-group-recs]"));
    if (!sections.length) return false;
    sections.forEach(function (section) {
      var groupKey = section.getAttribute("data-ap-cart-group-recs");
      var sourceProductId = section.getAttribute("data-ap-cart-group-recs-source");
      var track = root.querySelector('[data-ap-cart-group-recs-track="' + cssEscape(groupKey) + '"]');
      if (!groupKey || !sourceProductId || !track) return;
      var cacheKey = groupKey + ":" + sourceProductId;
      if (state.groupRecommendations[groupKey] === cacheKey && track.children.length) return;
      state.groupRecommendations[groupKey] = cacheKey;
      section.hidden = true;
      track.innerHTML = "";
      if (state.groupRecommendationAborts[groupKey]) state.groupRecommendationAborts[groupKey].abort();
      state.groupRecommendationAborts[groupKey] = new AbortController();
      fetch("/recommendations/products.json?product_id=" + encodeURIComponent(sourceProductId) + "&limit=6&intent=complementary", {
        credentials: "same-origin",
        signal: state.groupRecommendationAborts[groupKey].signal,
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        return filterRecommendationProducts(products, sourceProductId);
      }).then(function (products) {
        products = products || [];
        if (!products.length) return;
        return Promise.all(products.map(enrichProduct)).then(function (enriched) {
          track.innerHTML = enriched.map(function (product, index) {
            return renderRecommendationCard(product, index);
          }).join("");
          section.hidden = false;
        });
      }).catch(function () {});
    });
    return true;
  }

  function filterRecommendationProducts(products, sourceProductId) {
    return (products || []).filter(function (product) {
      return product
        && String(product.id) !== String(sourceProductId)
        && product.available !== false
        && product.variants
        && product.variants[0];
    }).slice(0, 6);
  }

  function recommendationSourceItem(cart) {
    var items = eligibleItems(cart);
    if (!items.length) return null;
    return items[0];
  }

  function productJsonUrl(product) {
    if (product && product.handle) return "/products/" + encodeURIComponent(product.handle) + ".js";
    if (product && product.url) return product.url.split("?")[0].replace(/\/$/, "") + ".js";
    return "";
  }

  function enrichProduct(product) {
    var url = productJsonUrl(product);
    if (!url) return Promise.resolve(product);
    return fetch(url, {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (res) {
      return res.ok ? res.json() : product;
    }).then(function (fullProduct) {
      return Object.assign({}, product, fullProduct || {});
    }).catch(function () {
      return product;
    });
  }

  function variantOptions(product, recId) {
    var variants = (product.variants || []).filter(function (variant) {
      return variant && variant.available !== false;
    });
    if (!variants.length) return "";
    return [
      '<label class="ap-cart__rec-control">',
        '<span class="visually-hidden">Variant</span>',
        '<select data-ap-cart-rec-variant="' + escapeHtml(recId) + '">',
          variants.map(function (variant) {
            return '<option value="' + escapeHtml(variant.id) + '" data-price="' + escapeHtml(normalizePrice(variant.price)) + '">' + escapeHtml(variant.title || "Default") + '</option>';
          }).join(""),
        '</select>',
      '</label>'
    ].join("");
  }

  function premiumTitle(title) {
    return String(title || "")
      .replace(/\s*[|-]\s*Premium Long-Lasting.*$/i, "")
      .replace(/\s*Premium Long-Lasting.*$/i, "")
      .replace(/\s*Perfume Inspired.*$/i, "")
      .replace(/\s*Inspired By.*$/i, "")
      .replace(/\s*For Humidifying Diffusers.*$/i, "")
      .replace(/\s*Waterless Fragrance Oil.*$/i, "")
      .replace(/\s*Fragrance Oil.*$/i, "")
      .replace(/\s*[–—-]\s*$/g, "")
      .trim();
  }

  function discountBadge(price, compare) {
    price = normalizePrice(price);
    compare = normalizePrice(compare);
    if (!price || !compare || compare <= price) return "";
    return '<span class="ap-cart__rec-badge">-' + Math.round(((compare - price) / compare) * 100) + '%</span>';
  }

  function renderRecommendationCard(product, index) {
        var variant = product.variants[0];
        var image = productImage(product);
        var price = productPrice(product, variant);
        var recId = "rec-" + index + "-" + String(product.id || product.handle || variant.id).replace(/[^a-zA-Z0-9_-]/g, "");
        var productUrl = product.url || ("/products/" + product.handle);
        var compare = normalizePrice((variant && variant.compare_at_price) || product.compare_at_price);
        var comparePrice = compare && compare > normalizePrice(variant.price)
          ? '<span class="ap-cart__rec-compare">' + money(compare) + '</span>'
          : "";
        return [
          '<article class="ap-cart__rec" data-ap-cart-rec="' + escapeHtml(recId) + '" data-ap-cart-rec-product="' + escapeHtml(product.id) + '">',
            '<a class="ap-cart__rec-media" href="' + escapeHtml(productUrl) + '" aria-label="View ' + escapeHtml(product.title) + '">',
              image ? '<img src="' + escapeHtml(imageUrl(image, 320)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : "",
            '</a>',
            '<div class="ap-cart__rec-main">',
              '<a class="ap-cart__rec-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(premiumTitle(product.title)) + '</a>',
              '<div class="ap-cart__rec-rating" aria-label="Customer rating"><span aria-hidden="true">★★★★★</span></div>',
              variantOptions(product, recId),
            '</div>',
            '<div class="ap-cart__rec-side">',
              '<p class="ap-cart__rec-price" data-ap-cart-rec-price>' + (price ? escapeHtml(price) : '&nbsp;') + comparePrice + '</p>',
              '<button type="button" class="ap-cart__rec-add" data-ap-cart-add-rec="' + escapeHtml(recId) + '" data-ap-cart-add-variant="' + escapeHtml(variant.id) + '" aria-label="Add ' + escapeHtml(product.title) + ' to cart">',
                '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6.5 7h13l-1.4 8.2a2 2 0 0 1-2 1.7H9.3a2 2 0 0 1-2-1.7L6.1 4.8H3.8"/><circle cx="9.7" cy="20" r="1.1"/><circle cx="16.7" cy="20" r="1.1"/></svg>',
              '</button>',
            '</div>',
          '</article>'
        ].join("");
  }

  function productImage(product) {
    var image = product && (product.featured_image || product.image || (product.images && product.images[0]));
    if (image && image.src) return image.src;
    return image || "";
  }

  function checkout(withProtection) {
    var cart = state.cart || { items: [] };
    if (!eligibleItems(cart).length) {
      showError("Add an item to your cart before checkout.");
      return Promise.resolve();
    }
    if (withProtection) {
      window.location.href = protectionItem(cart) || !root.dataset.protectionVariantId
        ? checkoutUrl()
        : checkoutAddUrl(root.dataset.protectionVariantId);
      return Promise.resolve();
    }
    var protection = protectionItem(cart);
    if (protection) {
      return changeLine(protection.key, 0).then(function () {
        window.location.href = checkoutUrl();
      }).catch(function () {
        window.location.href = checkoutUrl();
      });
    }
    window.location.href = checkoutUrl();
    return Promise.resolve();
  }

  function bindEvents() {
    document.addEventListener("submit", function (event) {
      if (!root.classList.contains("is-enabled")) return;
      var form = event.target && event.target.closest && event.target.closest("form[action*='/cart/add']");
      if (!form || form.closest("[data-ap-cart]")) return;
      event.preventDefault();
      event.stopPropagation();
      submitProductAddForm(form);
    }, true);

    root.addEventListener("click", function (event) {
      var close = event.target.closest("[data-ap-cart-close]");
      if (close) {
        event.preventDefault();
        closeCart();
        return;
      }
      var qty = event.target.closest("[data-ap-cart-qty]");
      if (qty) {
        event.preventDefault();
        var lineKey = qty.getAttribute("data-ap-cart-qty");
        var nextQty = Number(qty.getAttribute("data-qty"));
        var currentLine = cartLineByKey(lineKey);
        var previousQty = currentLine ? Number(currentLine.quantity || 0) : null;
        setLineBusy(lineKey, true);
        changeLine(lineKey, nextQty).then(function () {
          trackCartEvent(nextQty <= 0 ? "cart_item_removed" : "cart_quantity_changed", {
            line_key: lineKey,
            quantity: nextQty,
            previous_quantity: previousQty,
            product_id: currentLine && currentLine.product_id ? currentLine.product_id : "",
            variant_id: currentLine && currentLine.variant_id ? currentLine.variant_id : "",
            product_title: currentLine && currentLine.product_title ? currentLine.product_title : ""
          });
        }).catch(function () {
          showError("We couldn't update this item. Please try again.");
        }).finally(function () {
          setLineBusy(lineKey, false);
        });
        return;
      }
      var add = event.target.closest("[data-ap-cart-add-variant]");
      if (add) {
        event.preventDefault();
        var originalLabel = add.textContent;
        var isIconButton = add.classList.contains("ap-cart__rec-add");
        var recCard = add.closest("[data-ap-cart-rec]");
        if (recCard) {
          recCard.classList.remove("is-adding", "is-added");
          void recCard.offsetWidth;
          recCard.classList.add("is-adding");
        }
        setCartMutating(true);
        add.disabled = true;
        add.classList.add("is-busy");
        if (!isIconButton) add.textContent = "Adding";
        addVariant(add.getAttribute("data-ap-cart-add-variant"), 1).then(function () {
          var recSource = recommendationSource(recCard);
          var recPayload = Object.assign({
            variant_id: add.getAttribute("data-ap-cart-add-variant") || "",
            recommendation_id: recCard ? recCard.getAttribute("data-ap-cart-rec") || "" : "",
            product_id: recCard ? recCard.getAttribute("data-ap-cart-rec-product") || "" : ""
          }, recSource);
          trackCartEvent("recommendation_added", recPayload);
          if (recSource.source === "bundle_suggestion") {
            trackCartEvent("bundle_suggestion_added", recPayload);
          }
          if (!isIconButton) add.textContent = "Added";
          add.classList.add("is-added");
          if (recCard) {
            recCard.classList.remove("is-added");
            void recCard.offsetWidth;
            recCard.classList.add("is-added");
          }
        }).catch(function () {
          showError("We couldn't add that product. Please try again.");
          if (!isIconButton) add.textContent = originalLabel;
        }).finally(function () {
          window.setTimeout(function () {
            add.disabled = false;
            add.classList.remove("is-busy");
            add.classList.remove("is-added");
            if (recCard) recCard.classList.remove("is-adding", "is-added");
            setCartMutating(false);
            if (!isIconButton) add.textContent = originalLabel;
          }, 700);
        });
        return;
      }
      if (event.target.closest("[data-ap-cart-loyalty-toggle]")) {
        event.preventDefault();
        toggleLoyaltyAccordion();
        var loyaltyHost = root.querySelector("[data-ap-cart-loyalty]");
        trackCartEvent("rewards_toggled", {
          expanded: loyaltyHost ? loyaltyHost.getAttribute("data-ap-loyalty-expanded") === "true" : false
        });
        return;
      }
      var bundleSuggestionsButton = event.target.closest("[data-ap-cart-bundle-suggestions-prev], [data-ap-cart-bundle-suggestions-next]");
      if (bundleSuggestionsButton) {
        event.preventDefault();
        var bundleKey = bundleSuggestionsButton.getAttribute("data-ap-cart-bundle-suggestions-prev") || bundleSuggestionsButton.getAttribute("data-ap-cart-bundle-suggestions-next");
        var bundleTrack = root.querySelector('[data-ap-cart-bundle-suggestions-track="' + cssEscape(bundleKey) + '"]');
        var bundleDirection = bundleSuggestionsButton.hasAttribute("data-ap-cart-bundle-suggestions-prev") ? -1 : 1;
        if (bundleTrack) {
          bundleTrack.scrollBy({
            left: bundleDirection * Math.max(150, Math.round(bundleTrack.clientWidth * 0.82)),
            behavior: "smooth"
          });
        }
        return;
      }
      var groupRecsButton = event.target.closest("[data-ap-cart-group-recs-prev], [data-ap-cart-group-recs-next]");
      if (groupRecsButton) {
        event.preventDefault();
        var groupKey = groupRecsButton.getAttribute("data-ap-cart-group-recs-prev") || groupRecsButton.getAttribute("data-ap-cart-group-recs-next");
        var groupTrack = root.querySelector('[data-ap-cart-group-recs-track="' + cssEscape(groupKey) + '"]');
        var groupDirection = groupRecsButton.hasAttribute("data-ap-cart-group-recs-prev") ? -1 : 1;
        if (groupTrack) {
          groupTrack.scrollBy({
            left: groupDirection * Math.max(150, Math.round(groupTrack.clientWidth * 0.82)),
            behavior: "smooth"
          });
        }
        return;
      }
      if (event.target.closest("[data-ap-cart-recs-prev], [data-ap-cart-recs-next]")) {
        event.preventDefault();
        var track = root.querySelector("[data-ap-cart-recs-track]");
        var direction = event.target.closest("[data-ap-cart-recs-prev]") ? -1 : 1;
        if (track) {
          track.scrollBy({
            left: direction * Math.max(150, Math.round(track.clientWidth * 0.82)),
            behavior: "smooth"
          });
        }
        return;
      }
      if (event.target.closest("[data-ap-cart-checkout-plus]")) {
        event.preventDefault();
        var checkoutButton = event.target.closest("[data-ap-cart-checkout-plus]");
        checkoutButton.classList.add("is-busy");
        trackCartEvent("checkout_plus_clicked", { checkout_plus: true });
        checkout(true).catch(function () {
          checkoutButton.classList.remove("is-busy");
          showError("Checkout couldn't start. Please try again.");
        });
        return;
      }
      if (event.target.closest("[data-ap-cart-checkout-without]")) {
        event.preventDefault();
        var withoutButton = event.target.closest("[data-ap-cart-checkout-without]");
        withoutButton.classList.add("is-busy");
        trackCartEvent("continue_without_checkout_plus", { checkout_plus: false });
        checkout(false).catch(function () {
          withoutButton.classList.remove("is-busy");
          window.location.href = checkoutUrl();
        });
      }
    });

    root.addEventListener("change", function (event) {
      var variantSelect = event.target.closest("[data-ap-cart-rec-variant]");
      if (!variantSelect) return;
      var rec = variantSelect.closest("[data-ap-cart-rec]");
      var selected = variantSelect.options[variantSelect.selectedIndex];
      var button = rec && rec.querySelector("[data-ap-cart-add-variant]");
      var price = rec && rec.querySelector("[data-ap-cart-rec-price]");
      if (button) button.setAttribute("data-ap-cart-add-variant", variantSelect.value);
      if (price && selected && selected.getAttribute("data-price")) {
        price.textContent = money(selected.getAttribute("data-price"));
      }
      trackCartEvent("recommendation_variant_selected", {
        variant_id: variantSelect.value,
        recommendation_id: rec ? rec.getAttribute("data-ap-cart-rec") || "" : "",
        product_id: rec ? rec.getAttribute("data-ap-cart-rec-product") || "" : "",
        price: selected && selected.getAttribute("data-price") ? Number(selected.getAttribute("data-price")) / 100 : ""
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && root.classList.contains("is-open")) closeCart();
    });

    document.addEventListener("click", function (event) {
      if (!root.classList.contains("is-enabled")) return;
      var panel = root.querySelector(".ap-cart__panel");
      if (root.classList.contains("is-open") && panel && !panel.contains(event.target)) {
        event.preventDefault();
        event.stopPropagation();
        closeCart();
        return;
      }
      var cartLink = event.target.closest("#cart-icon-bubble, a[href='/cart'], a[href$='/cart']");
      if (!cartLink) return;
      event.preventDefault();
      event.stopPropagation();
      openCart();
    }, true);

    ["cart:added", "cart:refresh", "cart:updated", "UPEZ__ADDED_ITEM", "UPEZ__CART_REFETCHED_AFTER_ADD", "UPEZ__CART_REFETCHED_AFTER_CHANGE", "UPEZ__REMOVED_ITEM"].forEach(function (name) {
      document.addEventListener(name, function () {
        if (root.classList.contains("is-enabled")) {
          scheduleCartRefresh(140);
        }
      });
    });
  }

  function submitProductAddForm(form) {
    var submitter = document.activeElement && form.contains(document.activeElement)
      ? document.activeElement
      : form.querySelector("[type='submit']");
    var formData = new FormData(form);
    var variantId = formData.get("id") || "";
    var quantity = Number(formData.get("quantity") || 1);
    if (submitter) {
      submitter.disabled = true;
      submitter.classList.add("is-busy");
    }
    api(hiddenCartUrl("/cart/add.js"), {
      method: "POST",
      body: formData
    }).then(function () {
      clearError();
      return openOrRefreshAfterAdd().then(function () {
        trackCartEvent("cart_product_form_added", {
          variant_id: variantId,
          quantity: quantity,
          source: "product_form"
        });
      });
    }).catch(function () {
      showError("We couldn't add that product. Please try again.");
    }).finally(function () {
      if (submitter) {
        submitter.disabled = false;
        submitter.classList.remove("is-busy");
      }
    });
  }

  function patchCartMutations() {
    if (window.__apCartDrawerPatched) return;
    window.__apCartDrawerPatched = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var args = Array.prototype.slice.call(arguments);
      if (root.classList.contains("is-enabled") && isAdd && typeof input === "string") {
        args[0] = hiddenCartUrl(input);
      }
      var result = nativeFetch.apply(this, args);
      if (root.classList.contains("is-enabled") && isAdd) {
        result.then(function (res) {
          if (res && res.ok) setTimeout(openOrRefreshAfterAdd, 180);
        }).catch(function () {});
      }
      return result;
    };

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      var args = Array.prototype.slice.call(arguments);
      if (root.classList.contains("is-enabled") && /\/cart\/add(\.js)?(\?|$)/.test(String(url || ""))) {
        args[1] = hiddenCartUrl(url);
      }
      this.__apCartDrawerUrl = args[1];
      return nativeOpen.apply(this, args);
    };
    XMLHttpRequest.prototype.send = function () {
      if (root.classList.contains("is-enabled") && /\/cart\/add(\.js)?(\?|$)/.test(this.__apCartDrawerUrl || "")) {
        this.addEventListener("loadend", function () {
          if (this.status >= 200 && this.status < 300) setTimeout(openOrRefreshAfterAdd, 180);
        });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  function warmBundleGroups() {
    if (state.bundleGroupsLoaded || state.bundleGroupsLoading) return;
    if (readBundleGroupCache()) return;
    var warm = function () { loadBundleGroups(); };
    if ("requestIdleCallback" in window) window.requestIdleCallback(warm, { timeout: 1800 });
    else window.setTimeout(warm, 900);
  }

  function init() {
    if (!hasFlag()) return;
    root.classList.add("is-enabled");
    document.body.classList.add("ap-cart-native-mode");
    window.apCartDrawer = {
      open: openCart,
      close: closeCart,
      refresh: fetchCart,
      disable: function () {
        window.localStorage.removeItem(FLAG);
        closeCart();
        root.classList.remove("is-enabled");
        document.body.classList.remove("ap-cart-native-mode");
      }
    };
    bindEvents();
    patchCartMutations();
    installScrollStyles();
    installScrollGuards();
    fetchCart().then(bridgeLoyaltyWidget);
    warmCartGrouping();
    window.setTimeout(bridgeLoyaltyWidget, 900);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
